import {z} from "zod";

export const tableURLStateSchema = z.object({
  page: z.number().catch(1),
  perPage: z.number().catch(10),
  q: z.string().optional().catch(undefined),
  sortBy: z.string().optional().catch("editedAt"),
  sortDir: z.enum(["asc", "desc"]).catch("desc"),
});
